/*
 * サブシステム名：設定その他
 * 機能名：データ取込
 */

import DdDropDown from '@/components/DdDropDown'
import DdRadioButton from '@/components/DdRadioButton'
import DdSubHeader from '@/components/DdSubHeader'
import DdDefaultButton from '@/components/DdDefaultButton'
import DdNarrowDownTextBox from '@/components/DdNarrowDownTextBox'
import DdRowCountBox from '@/components/DdRowCountBox'
import DdFileInput from '@/components/DdFileInput'
import DdFooterButton from '@/components/DdFooterButton'
import DdDataTable from '@/components/DdDataTable'
import flowMixin from '@/mixins/flowMixins'
import { mapGetters } from 'vuex'
import dayjs from 'dayjs'

export default {
  name: 'DataImportList',
  mixins: [flowMixin],
  data: () => ({
    expansionPanel: [0, 1],
    conditions: {
      fileFormatCd: '',
      dataFile: {
        value: '',
        input: ''
      },
      torihikisakiKbn: '0'
    },
    modeKengen: 0
  }),
  components: {
    DdSubHeader,
    DdDropDown,
    DdRadioButton,
    DdDefaultButton,
    DdNarrowDownTextBox,
    DdRowCountBox,
    DdFileInput,
    DdFooterButton,
    DdDataTable
  },
  computed: {
    ...mapGetters({
      kubunList: 'DDMasters/msysKubun',
      fileFormatNm: 'DDMasters/mstFileFormatKihon'
    }),
    filteredFileFormatNm () {
      return this.fileFormatNm.filter(function (elem) {
        return elem.fileFormatCd < '900' && (elem.fileFormatKbn === '1' || elem.fileFormatKbn === '3')
      }).map(function (elem) {
        elem.value = elem.fileFormatCd
        elem.text = elem.fileFormatNm
        return elem
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.fileFormatCd > elem2.fileFormatCd) { return 1 }
        if (elem1.fileFormatCd === elem2.fileFormatCd) { return 0 }
        return -1
      })
    },
    filteredProcessKbn () {
      return this.kubunList.filter(function (elem) {
        return elem.kbnShuruiCd === 'KBN017'
      }).map(function (elem) {
        elem.code = elem.code.trim()
        return elem
      })
    },
    isValidImportButton () {
      if (this.modeKengen === 0) {
        return false
      }
      return true
    },
    isValidCSVTemplate () {
      if (this.conditions.fileFormatCd) {
        return true
      }
      return false
    },
    filteredRows () {
      return this.rows.map((elem) => {
        elem.importStartDisp = elem.importStart ? dayjs(elem.importStart).format('YYYY/MM/DD HH:mm:ss') : ''
        elem.importEndDisp = elem.importEnd ? dayjs(elem.importEnd).format('YYYY/MM/DD HH:mm:ss') : ''
        // elem.keiyakuKihonKingakuDisp = filter.numericFormatter(elem.keiyakuKihonKingaku)

        return elem
      })
    }
  },
  created () {
  },
  mounted () {
    this.initialize()
  },
  beforeRouteUpdate (to, from, next) {
    this.$refs.initialize()
    next()
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        rows: this.rows,
        conditions: this.conditions,
        searchText: this.searchText
      }
    },
    initialize: function () {
      const self = this
      const opt = {
        loadMasters: ['mstfileformatkihon', 'msyskubun'],
        defineHeaderPromise: () => {
          return new Promise(resolve => {
            self.headers = [
              { text: '取込指示日時', value: 'importStartDisp', align: 'center' },
              { text: '取込終了日時', value: 'importEndDisp', align: 'center' },
              { text: '取込指示者', value: 'importUserNm' },
              { text: '取込ファイル名', value: 'importFileName' },
              { text: '種類', value: 'fileFormatNm' },
              { text: '方法', value: 'codeNm' },
              { text: '取込結果', value: 'exportResult' },
              { text: '読込行数', value: 'importRowCnt' },
              { text: 'エラー行数', value: 'errorRowCnt' },
              { text: 'エラー情報', value: 'errorMsg' }
            ]
            resolve()
          }).then(() => {
            // 取込履歴一覧取得
            return new Promise(resolve => {
              this.HttpClient
                .post('/api/v1/vwCD2utld0010/search', { max: '899' })
                .then((data) => {
                  if (data.isValid) {
                    this.rows = data.payload
                  } else {
                    this.rows = []
                  }
                  resolve(data)
                })
            })
          })
        },
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            self.conditions = {
              fileFormatCd: '',
              processKbn: '1',
              filePath: '',
              fileName: ''
            }
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          // ユーザ保存項目の復元
          self.conditions = { ...self.conditions, ...c }
          return new Promise(resolve => {
            self.loadFromCache()
              .then((c) => {
                resolve()
              })
          })
        },
        researchPromise: (c) => {
          return new Promise(resolve => {
            self.conditions = c.cache.value.conditions || {}
            resolve()
          })
        },
        restoreViewPromise: (c) => {
          return new Promise(resolve => {
            self.conditions = c.cache.value.conditions || {}
            self.searchText = c.cache.value.searchText || ''
            self.rows = c.cache.value.rows || []
          })
        },
        settingButtonStatePromise: (kengen) => {
          return new Promise(resolve => {
            console.log('settingButtonStatePromise', kengen)
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }
            resolve()
          })
        }
      }
      this.initializeForViewer(opt)
    },
    clear: function () {
      console.log('clear pushed')
      const opt = {
        clearInputsPromise: () => {
          return new Promise(resolve => {
            this.conditions = {
              fileFormatCd: '',
              processKbn: '1',
              filePath: '',
              fileName: ''
            }
            this.searchText = ''
            this.rows = []
            resolve()
          })
        }
      }
      this.clearInputs(opt)
    },
    onTorikomiButtonClick: function (e) {
      console.log('cklick')
      if (this.validateAll(this.$refs)) {
        this.Effects.loadStart()
        console.log('TorikoMI start', e)
        this.HttpClient.post('/api/v1/D2UTLD0010/Exec', this.conditions)
          .then((data) => {
            if (data.isValid) {
              console.log('retdata', data)
              this.transition(0, { id: data.payload, edit: 1 })
            } else {
              this.setSummaryMessage(data.summaryMessage)
              this.Effects.loadComplete()
            }
          }).catch((e) => {
            console.log('error', e)
            this.setSummaryMessage(e.message)
            this.Effects.loadComplete()
          })
      }
    },
    onClearButtonClick: function (e) {
      console.log('clear pushed')
      this.Effects.loadStart()
      this.clear()
    },
    onRowClick: function (e) {
      console.log(e)
      this.Effects.loadStart()

      this.transition(0, { id: e.id, edit: 0 })
    },
    searchValidate: function () {
      return true
    },
    storeFileInfo: function (file) {
      console.log('file selected', file)

      if (file === undefined || file === null) {
        this.conditions.fileData = ''
        this.conditions.fileName = ''
        return
      }
      this.conditions.fileName = file.name

      const fr = new FileReader()
      fr.readAsDataURL(file)
      fr.addEventListener('load', () => {
        this.conditions.fileData = fr.result
      })
      console.log('file selected e')
    },
    CSVtemplateClick: function (e) {
      console.log('csvtemplate clicked')
      // TODO call file export only headers
    }
  }
}
